import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
  CallCoreServicesAction,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
import { Button, Modal, Radio, Tag, message } from "antd";
import { ReactSketchCanvas } from "react-sketch-canvas";
import { TypeList } from "../../../component/utility";
import { ArrowDownOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { typeList } from "antd/lib/message";
const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;
function Analyses(props) {
  const { imageId } = useParams();
  const [image, setImage] = useState(null);
  const [listAnalyses, setListAnalyse] = useState([]);
  const [scale, setScale] = useState(0.5);
  const [imageCrop, setImageCrop] = useState(null);

  const [showModal, setShowmodal] = useState(false);

  const [listPath, setListPath] = useState([]);
  const [newpath, setNewPath] = useState(null);

  const [selectType, setSelectType] = useState(null);

  const refScatch = useRef(null);

  let navigation = useNavigate();
  useEffect(() => {
    if (refScatch.current) {
      refScatch.current.resetCanvas();
    }
  }, [imageCrop]);
  useEffect(() => {
    _getInfo();
    GetOpgPhoto();
  }, []);

  const _getInfo = async () => {
    let url = Url.GetImageNotIntact;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: imageId,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    _getsegment();

    setImage(res?.data?.image);

    console.log(
      res?.data?.analyses?.numberingTeethAnalyseDetails?.filter(
        (o) => o.intact == "Notintact"
      )
    );

    setListAnalyse(
      res?.data?.analyses?.numberingTeethAnalyseDetails?.filter(
        (o) => o.intact == "Notintact"
      )
    );
  };

  const GetOpgPhoto = async () => {
    let url = Url.GetOpgPhotonumbering;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: imageId,
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);

      return;
    }
  };

  const _getsegment = async () => {
    let url = Url.GetSegment;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      id: imageId,
    });

    let _newPath = [];

    for (let index = 0; index < res?.data?.filteredAnalyses.length; index++) {
      const element = res?.data?.filteredAnalyses[index];
      for (
        let indexSegment = 0;
        indexSegment < element.segmentAnalysiss.length;
        indexSegment++
      ) {
        const elementSegment = element.segmentAnalysiss[indexSegment];
        _newPath.push({
          id: elementSegment.numberingTeethAnalyseDetailId,
          problem: elementSegment.problem,
          paths: elementSegment.segmentAnalysisPaths,
          toothNumber: element.type,
          x: element.x,
          y: element.y,
          w: element.w,
          h: element.h,
        });
      }
    }

    console.log(_newPath);

    setListPath(_newPath);
  };

  const _returnRect = () => {
    let _output = [];

    listAnalyses.map((o) => {
      _output.push(
        <g>
          <rect
            className="rectEdit"
            onClick={() => setImageCrop(o)}
            x={o.x * scale}
            y={o.y * scale}
            width={o.w * scale}
            height={o.h * scale}
            stroke="red"
            fill="#ffffff00"
          />
          <text x={o.x * scale} y={o.y * scale} fill="blue">
            {o.type}
          </text>
        </g>
      );
    });

    for (let i = 0; i < listPath.length; i++) {
      let Object = listPath[i];
      let color = TypeList.find((l) => l.value == Object.problem)?.color;
      let points = "";

      Object?.paths?.map((pathObj) => {
        let _x = (Object.x + pathObj.x) * scale;
        let _y = (Object.y + pathObj.y) * scale;
        points = points + _x + "," + _y + " ";
      });
      _output.push(
        <polyline
          points={points}
          style={{ stroke: "red", strokeWidth: 1, fill: color }}
        />
      );
    }

    return _output;
  };

  useEffect(() => {
    console.log(listPath);
  }, [listPath]);
  const onStroke = (e) => {
    if (e.paths.length > 1) {
      let _newobj = {
        id: imageCrop.id,
        x: imageCrop.x,
        y: imageCrop.y,
        w: imageCrop.w,
        h: imageCrop.h,
        paths: e.paths,
      };
      setSelectType(null);
      setShowmodal(true);
      setNewPath(e.paths);
    }
  };

  let pointPolygan = "";
  newpath?.map((o) => {
    let _x = o.x;
    let _y = o.y;
    pointPolygan = pointPolygan + _x + "," + _y + " ";
  });

  const onClickType = (type) => {
    setSelectType(type);

    console.log(imageCrop);
    // console.log(type);
    // console.log(newpath);

    let _newobj = {
      id: imageCrop.id,
      x: imageCrop.x,
      y: imageCrop.y,
      w: imageCrop.w,
      h: imageCrop.h,
      toothNumber: imageCrop?.type,
      paths: newpath,
      problem: type,
    };

    setListPath([...listPath, _newobj]);
    setSelectType(null);
    setShowmodal(false);
    setImageCrop(null);
    setNewPath(null);
  };

  const onClickSaveAll = async () => {
    let _toServer = [];

    listPath.map((o) => {
      _toServer.push({
        imageId: imageId,
        NumberTeethAnalyseId: o.id,
        problem: o.problem,
        paths: o.paths,
      });
    });

    let url = Url.SaveSegment;

    let res = await props.actions.CallCoreServicesActionWithToken(
      url,
      _toServer
    );

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
    message.success(res.message);
    navigation("/segmentcaries/main");
  };
  return (
    <div dir="ltr">
      <Modal
        open={showModal}
        onCancel={() => {
          setImageCrop(null);
          setShowmodal(false);
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: imageCrop?.w,
                height: imageCrop?.h,
                backgroundColor: "red",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <svg
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: imageCrop?.w,
                  height: imageCrop?.h,
                  zIndex: 20,
                }}
              >
                <polyline
                  points={pointPolygan}
                  style={{ stroke: "red", strokeWidth: 1, fill: "#ffffff80" }}
                ></polyline>
              </svg>
              <img
                style={{
                  position: "absolute",
                  top: -1 * imageCrop?.y,
                  left: -1 * imageCrop?.x,
                }}
                src={ImagePreAddress + image?.imageUrl}
              />
            </div>
            <div>
              <ArrowRightOutlined />
            </div>
            <div
              style={{
                width: imageCrop?.w,
                height: imageCrop?.h,
                backgroundColor: "red",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <img
                style={{
                  position: "absolute",
                  top: -1 * imageCrop?.y,
                  left: -1 * imageCrop?.x,
                }}
                src={ImagePreAddress + image?.imageUrl}
              />
            </div>
          </div>

          <div>
            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              size="small"
              value={selectType}
              onChange={(e) => onClickType(e.target.value)}
            >
              {TypeList.map((o) => (
                <Radio.Button value={o.value}>{o.title}</Radio.Button>
              ))}
            </Radio.Group>
          </div>
        </div>
      </Modal>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minWidth: 150,
            backgroundColor: "grey",
            justifyContent: "space-between",
          }}
        >
          <div>
            {listPath.map((o) => {
              let color = TypeList.find((l) => l.value == o.problem)?.color;
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    backgroundColor: color,
                  }}
                >
                  <div>
                    {o.toothNumber}/{o.problem}
                  </div>
                  <div>
                    <Tag
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setListPath(listPath.filter((item) => item.id != o.id));
                      }}
                    >
                      Delete
                    </Tag>
                    {/* <Button
                    danger
                    onClick={() => {
                      setListPath(listPath.filter((item) => item.id != o.id));
                    }}
                  >
                    Delete
                  </Button> */}
                  </div>
                </div>
              );
            })}
          </div>

          <Button
            onClick={onClickSaveAll}
            loading={props.coreData[Url.SaveSegment]?.[Url.action]?.isFetching}
            type="primary"
          >
            Save
          </Button>
        </div>
        <div>
          <img
            className="imgdragdisable"
            style={{ maxWidth: 400 }}
            src={
              ImagePreAddress +
              props.coreData[Url.GetOpgPhotonumbering]?.[Url.action]?.data
                ?.imageUrl
            }
          />
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {image && (
            <div
              style={{
                position: "relative",
                width: image?.imageWidth * scale,
                height: image?.imageHeight * scale,
              }}
            >
              <svg
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: image?.imageWidth * scale,
                  height: image?.imageHeight * scale,
                  zIndex: 10,
                }}
              >
                {_returnRect()}
              </svg>
              <img
                className="imgdragdisable"
                src={ImagePreAddress + image?.imageUrl}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,

                  width: image?.imageWidth * scale,
                  height: image?.imageHeight * scale,
                }}
              />
            </div>
          )}

          {imageCrop && (
            <>
              <div
                style={{
                  width: imageCrop.w,
                  height: imageCrop.h,
                  backgroundColor: "red",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  className="imgdragdisable"
                  src={ImagePreAddress + image?.imageUrl}
                  style={{
                    position: "absolute",
                    top: -1 * imageCrop.y,
                    left: -1 * imageCrop.x,
                  }}
                />

                <ReactSketchCanvas
                  ref={refScatch}
                  style={{
                    position: "absolute",
                    width: imageCrop.w,
                    height: imageCrop.h,
                    zIndex: 40,
                  }}
                  strokeWidth={2}
                  strokeColor="black"
                  canvasColor="#ffffff20"
                  // onChange={(e) => console.log(e)}
                  onStroke={onStroke}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
const actionCreators = Object.assign(
  {},
  {
    CallCoreServicesAction,
    OfflineCoreServices,
    CallCoreServicesActionWithToken,
  }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});
const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
  token: state.coreservices.coreData?.token?.jwt?.data,
});
export default connect(mapStateToProps, mapDispatchToProps)(Analyses);
